// src/pages/OurReserve.js
import React, { useEffect } from 'react';
import SeoHead from '../seo/SeoHead';
import OurReserveHero from '../main/OurReserveHero';
import ReserveBody from '../main/ReserveBody';

export default function OurReserve() {
  // scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SeoHead
        title="Our Reserve – Morrocan Olive Oil Farm"
        description="Step into Marrakech Reserve, our family‑owned olive farm in the heart of Morocco. Learn how our sustainable cultivation, hand‑harvested groves, and artisanal milling produce the finest olive oil."
        url="https://marrakech-reserve.com/our-reserve"
        keywords={
          "olives, olive oil, Moroccan Olive Oil, olive farm Marrakech, Marrakech olive groves, sustainable olive farming, Moroccan olive farm, " +
          "hand-harvested olives, organic olive cultivation, farm-to-bottle olive oil, artisanal milling, " +
          "family-owned olive reserve, terroir-driven olive oil, Marrakech Reserve farm, " +
          "premium extra virgin olive oil, heritage olive orchard"
        }
      />
      <OurReserveHero />
      <ReserveBody />
    </>
  );
}
